import { template as template_c3ba7ea4e3f74944867ff935ee137340 } from "@ember/template-compiler";
import { serviceHelper as service } from 'eflex/helpers';
import BsForm from 'eflex/components/bs-form';
import { t } from 'ember-intl';
const getDisplayedSerialNumber = (buildStatus, intl)=>{
    const serialNumber = buildStatus?.serialNumber;
    if (serialNumber != null) {
        return serialNumber;
    } else if (buildStatus != null) {
        return intl.t('controls.ajaxindicator.loading');
    } else {
        return intl.t('plant.station.jem.unknown');
    }
};
export default template_c3ba7ea4e3f74944867ff935ee137340(`
<BsForm @model={{this}} @readonly={{true}} class="w-100" as |form|>
  {{#let (service 'intl') as |intl|}}
    <form.element
      class="mb-0"
      @label={{t "serialNumberAbbr"}}
      @controlType="text"
      @size="lg"
      @value={{getDisplayedSerialNumber @buildStatus intl}}
    as |el|>
      <el.control class="jem-serial-display preserve-spaces fw-semibold" ...attributes />
    </form.element>
  {{/let}}
</BsForm>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
